<template>
  <div class="pt-8">
    <div v-if="spots && spots.items" class="row">
      <div
        v-for="(spot, i) in spots.items"
        :key="i"
        class="col-md-6 col-lg-4 mb-6"
      >
        <spot-item-list :spot-item="spot" />
      </div>
    </div>
  </div>
</template>

<script>
import SpotItemList from '@/components/molecules/SpotItemList';
export default {
  name: 'SearchResultContent',
  components: {
    SpotItemList
  },
  props: {
    spots: {
      type: Object,
      default: () => {}
    },
  },
}
</script>